import { render } from "./GridCardsApontamentosAbertos.vue?vue&type=template&id=2bbed354&scoped=true"
import script from "./GridCardsApontamentosAbertos.vue?vue&type=script&lang=js"
export * from "./GridCardsApontamentosAbertos.vue?vue&type=script&lang=js"

import "./GridCardsApontamentosAbertos.vue?vue&type=style&index=0&id=2bbed354&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\apontamentowebvueV3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbed354"]])

export default __exports__